import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import VerticalBarChart from "./vertical-bar-chart"
import HorizontalBarChart from "./horizontal-bar-chart"
import BumpChart from "./bump-chart"
import PieChart from "./pie-chart"
import LineChart from "./line-chart"

export default function ChartHandler(props) {
  const chartType = props.chart_type.split(" ").join("")
  const chartClass = props.chart_type.split(" ").join("-").toLowerCase()

  // This is where we define the components based on the chart type we receive as props
  const chartComponents = {
    "VerticalBarChart": VerticalBarChart,
    "HorizontalBarChart": HorizontalBarChart,
    "PieChart": PieChart,
    "StackedBarChart": PieChart,
    "BumpChart": BumpChart,
    "LineChart": LineChart,
  };

  const ChartComponent = chartComponents[chartType];

  const allChartData = useStaticQuery(graphql`
    {
      allYear2022Xml {
        edges {
          node {
            attributes {
              qID
              question
            }
            id
            xmlChildren {
              children {
                content
                name
                attributes {
                  total
                }
              }
              content
              name
            }
          }
        }
      },
      allMultiyearXml {
        edges {
          node {
            attributes {
              qID
              question
            }
            id
            xmlChildren {
              children {
                attributes {
                  response
                }
                children {
                  attributes {
                    total
                    ranking
                    percent
                  }
                  content
                }
              }
            }
          }
        }
      }
    }
  `)

  const fullCustomScheme = ['#310707','#560B0B', '#810000', '#960000', '#AA0000', '#BB0000', '#D60000', '#E03535', '#EA4646']
  const minimalColorScheme = ['#810000', '#BB0000', '#EA4646']

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  function renderChart(){
    const limitedChartData = props.is_multiyear ? allChartData.allMultiyearXml.edges : allChartData.allYear2022Xml.edges;

    let chartHeight = 500;

    if (props.custom_chart_height !== null){
      chartHeight = props.custom_chart_height;
    } else if (chartType === 'PieChart'){
      chartHeight = 400;
    }

    return(
      <div>
        {limitedChartData.map(chartData => {
          const qID = chartData.node.attributes.qID;
          const question = chartData.node.attributes.question;

          // eslint-disable-next-line no-prototype-builtins
          if(chartData.hasOwnProperty("node")){

            return (
              chartData.node.xmlChildren.map(xmlChild => {
                // eslint-disable-next-line no-prototype-builtins
                const custom_scheme = xmlChild.children.length > 3 ? fullCustomScheme : minimalColorScheme
                shuffleArray(custom_scheme)

                // eslint-disable-next-line no-prototype-builtins
                if (xmlChild.hasOwnProperty("children") && props.crowdsignal_question_number === qID) {
                  return (
                    <div key={qID} className={`is-chart-container is-${chartClass}`} style={{height: chartHeight + "px"}}>
                      <ChartComponent xmlChildren={xmlChild.children} qID={qID} question={question} uses_legend={props.uses_legend} custom_scheme={custom_scheme} />
                    </div>
                  )
                } else if (qID === null){
                  return (
                    null
                    // <article className="message is-warning" key={props.crowdsignal_question_number}>
                    //   <div className="message-body">{ props.is_multiyear ? 'Multi year' : 'Single year' } data might be missing for this chart.</div>
                    // </article>
                  )
                } else {
                  return null
                }
              })
            )
          }
        })}
      </div>
    )
  }

  return (
    <>
      {renderChart()}
    </>
  )
}


ChartHandler.propTypes = {
  chart_type: PropTypes.string,
  is_multiyear: PropTypes.bool,
  crowdsignal_question_number: PropTypes.string,
  uses_legend: PropTypes.bool,
  custom_chart_height: PropTypes.number,
  custom_scheme: PropTypes.array,
}

ChartHandler.defaultProps = {
  chart_type: ``,
  is_multiyear: false,
  crowdsignal_question_number: ``,
  uses_legend: false,
  custom_chart_height: null,
  custom_scheme: [],
}
